// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__RxjTZ","table":"Table_table__7qGIa"};